// Author : Ayesha Shaikh
//  Dated : 2025-04-08

import React, { useEffect, useState } from "react";
import MainCard from "../../newTestPrep/components/ui-component/card/MainCard";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  CircularProgress,
  Typography,
  Divider,
  Grid,
  Stack,
  Pagination,
  Chip,
} from "@mui/material";
import { fDate } from "../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import TicketFilter from "./TicketFilter";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../utils/token";
import StyledTableContainer from "../../newTestPrep/newComponent/TableContainer";
import VeiwIcon from "../../newTestPrep/newComponent/iconsComp/VeiwIcon";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import FilterButtonComponent from "../../newTestPrep/newComponent/NewButtonComp/FilterButtonComponent";
import CustomNoRowsOverlay from "../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function Allticket() {
  // Sample data for demonstration
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [ticketdata, setticketdata] = useState([]);
  const [originalTicketData, setOriginalTicketData] =useState([])
  const [loading, setLoading] = useState(true); // Track loading state

  const [open, setOpen] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {

    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleToggle = () => {
    setOpen(!open);
  };
  const handleApplyFilter = (criteria) => {
    setFilterCriteria(criteria);
  };
  const handleResetFilter = () => {
    setFilterCriteria(null); // Reset filter criteria
    // setRows(originalRows); // Reset table data to original rows
  };
  useEffect(() => {
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    fetch(`${API_ENDPOINT}route/fetchtickets/${userId}`, { headers })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 403) {
          // Handle 403 error by showing Snackbar
          showSnackbar("No Ticket Found", "error");
          setLoading(false);
          return; // No need to continue further
        } else if (response.status === 401) {
          navigate("/");
          return showSnackbar("Unknown user:", "error");
        } else if (response.status === 404) {
          navigate("/page404");
          throw new Error(`Request failed with status: ${response.status}`);
        }
      })
      .then((data) => {
        if (!data) return; // Stop further execution if data is not present
        const activeTickets = data.filter((ticket) => ticket.is_active === 1);
        const sortedData = activeTickets.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
       

     
        setticketdata(sortedData);
        setOriginalTicketData(sortedData)
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
        navigate("/page404");
      });
  }, [filterCriteria, userId]);

  const handelclick = (ticketId) => {
    navigate(`/allticket/${ticketId}`);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      flex: 1.2,
      headerClassName: "header-cell",
      align: "center",
      headerAlign: "center",
      minWidth: 100,
      renderCell: (params) => (
        <div>
          <VeiwIcon
            fontSize="1rem"
            onClick={() => handelclick(params?.row?.id)}
          />
        </div>
      ),
    },

    {
      field: "type_of_ticket",
      headerName: "Type of Ticket",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      minWidth: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.type_of_ticket || "",
      renderCell: (params) => <div>{params?.row?.type_of_ticket}</div>,
    },

    {
      field: "urgency",
      headerName: "Urgency",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      minWidth: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row?.ticket_priority === 1 ? "Yes" : "No" || "",
      renderCell: (params) => (
        <div>{params?.row?.ticket_priority === 1 ? "Yes" : "No"}</div>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1.2,
      headerClassName: "header-cell",
      align: "center",
      headerAlign: "center",
      minWidth: 100,
      renderCell: (params) => (
        <div>
          {params?.row?.status === "created" ? (
            <Chip
              variant="contained"
              color="error"
              label="Created"
              size="small"
            />
          ) : params?.row?.status === "resolving" ? (
            <Chip
              variant="contained"
              color="warning"
              label="Resolving"
              size="small"
            />
          ) : params?.row?.status === "completed" ? (
            <Chip
              variant="contained"
              color="secondary"
              label="Closed"
              size="small"
            />
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params?.row?.enquiry_id?.created_by?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row?.created_by?.first_name}{" "}
          {params?.row?.created_by?.last_name}
        </div>
      ),
    },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1.2,
      align: "center",
      headerAlign: "center",
      minWidth: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => fDate(params?.row?.created_date) || "",
      renderCell: (params) => <div>{fDate(params?.row?.created_date)}</div>,
    },
  ];
  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={2}>
          <HeadingCard label="All Tickets" />
        </Grid>

        <Grid item xs={12} sm={12} md={10} textAlign="end">
          <FilterButtonComponent
            title="Filter"
            onClick={handleToggle}
            open={open}
            showendIcon={true}
          />
        </Grid>

        <Grid item xs={12}>
          {/* <Grid item xs={12} md={12} sm={12} lg={12}> */}
          <TicketFilter
          
            open={open}
            setOpen={setOpen}
            handleToggle={handleToggle}
            setLoading ={setLoading}
            setticketdata ={setticketdata}
            originalTicketData={originalTicketData}
          />
        </Grid>
        {/* </Grid> */}

        <Grid item xs={12}>
          <MainCard>
            {/* <StyledTableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  
                >
                  Actions
                </TableCell>
                <TableCell
                  
                >
                  Type of Ticket
                </TableCell>
                <TableCell
                 
                >
                  Created By
                </TableCell>
               
               
                <TableCell
                
                >
                  Urgency
                </TableCell>
                <TableCell
                 
                >
                  Status
                </TableCell>
              
                 <TableCell
            
                >
                  Created At
                </TableCell>
                  
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? ( // Conditionally render loader if loading is true
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
             height:'100vh',
         
                   
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                currentTickets.map((ticket, index) => (
                  <TableRow key={ticket.id}>
                     <TableCell>
                   
                      
                          <VeiwIcon
                          
                        fontSize="1rem"
                           
                            onClick={() => handelclick(ticket.id)}
                          />
                         
            
                    </TableCell>
                    <TableCell>{ticket.type_of_ticket}</TableCell>
                    <TableCell>{ticket.created_by?.first_name} </TableCell>
                 
                 
                    <TableCell>
                      {ticket.ticket_priority === 1 ? "Yes" : "No"}
                    </TableCell>
                    <TableCell>{ticket.status ==="created"? <Chip variant="contained"  color="error" label="Created" size="small"/> : 
                    ticket.status ==="resolving"? <Chip variant="contained"  color="warning" label="Resolving" size="small"/> :
                                        ticket.status ==="completed"? <Chip variant="contained"  color="secondary" label="Resolved" size="small"/> :""
                    }</TableCell>
                       <TableCell>{fDate(ticket.createdAt)}</TableCell>
                   
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </StyledTableContainer> */}

            <DataGrid
              rows={ticketdata}
              columns={columns}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              autoHeight
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
